import { TableActionsTypes } from 'constants/TableActionsTypes';
import { tabTableEditAction } from './default-table-actions/tabTableEditAction';
import { approveAction } from './default-table-actions/approveAction';
import { deleteAction } from './default-table-actions/deleteAction';
import { duplicateAction } from './default-table-actions/duplicateAction';
import { editAction } from './default-table-actions/editAction';
import { manageAction } from './default-table-actions/manageAction';
import { deactivateAction } from './default-table-actions/deactivateAction ';
import { viewResultAction } from './default-table-actions/viewResultAction';
import { customEditAction } from './default-table-actions/customEditAction';
import { defaultActionWithProgressBar } from './default-table-actions/defaultActionWithProgressBar';
import { defaultAction } from './default-table-actions/defaultAction';
import { deleteWithAction } from './default-table-actions/deleteWithAction';
import { impersonateAction } from './default-table-actions/impersonateAction';
import { toggleEnabledAction } from './default-table-actions/toggleEnabledAction';
import { changeStatusAction } from './default-table-actions/changeStatusAction';

const defaultTableActionConfig = [
    TableActionsTypes.Edit,
    TableActionsTypes.Delete,
    TableActionsTypes.Duplicate,
];

const defaultActions = [TableActionsTypes.Deactivate];
class ActionsBuilder {
    constructor(props) {
        this.actionConfig = props.config;
        this.service = props.service;
    }

    addActions() {
        const entity = this.service.getModel();
        defaultActions.forEach(
            x =>
                entity.ModelFeatureAttribute[x.toUpperCase()] &&
                !this.actionConfig.includes(x) &&
                this.actionConfig.push(x),
        );
        return this;
    }

    build(resultType = 'values') {
        this.addActions();
        const actions = this.actionConfig.map(action => {
            switch (action) {
                case TableActionsTypes.Edit:
                    return [action.toLowerCase(), editAction()];
                case TableActionsTypes.Approve:
                    return [action.toLowerCase(), approveAction(this.service)];
                case TableActionsTypes.Delete:
                    return [
                        action.toLowerCase(),
                        deleteAction({ service: this.service }),
                    ];

                case TableActionsTypes.Duplicate:
                    return [action.toLowerCase(), duplicateAction()];
                case TableActionsTypes.Deactivate:
                    return [
                        action.toLowerCase(),
                        deactivateAction(this.service),
                    ];
                case TableActionsTypes.Manage:
                    return [action.toLowerCase(), manageAction()];
                case TableActionsTypes.ManageLaptop:
                    return [
                        action.toLowerCase(),
                        manageAction(TableActionsTypes.ManageLaptop),
                    ];
                case TableActionsTypes.ManageTablet:
                    return [
                        action.toLowerCase(),
                        manageAction(TableActionsTypes.ManageTablet),
                    ];
                case TableActionsTypes.ViewResult:
                    return [action.toLowerCase(), viewResultAction()];
                case TableActionsTypes.Impersonate:
                    return [action.toLowerCase(), impersonateAction()];
                case TableActionsTypes.ToggleEnabled:
                    return [action.toLowerCase(), toggleEnabledAction()];
                case TableActionsTypes.ChangeStatus:
                    return [action.toLowerCase(), changeStatusAction({ service: this.service })];
                default:
                    switch (action.type) {
                        case TableActionsTypes.TabTableEdit:
                            return [
                                action.type.toLowerCase(),
                                tabTableEditAction(action),
                            ];
                        case TableActionsTypes.CustomEdit:
                            return [
                                action.type.toLowerCase(),
                                customEditAction(action),
                            ];
                        case TableActionsTypes.Delete:
                            return [
                                action.type.toLowerCase(),
                                deleteAction(action),
                            ];
                        case TableActionsTypes.DeleteWithAction:
                            return [
                                action.type.toLowerCase(),
                                deleteWithAction(action),
                            ];
                        case TableActionsTypes.DefaultActionWithProgressBar:
                            return [
                                action.type.toLowerCase(),
                                defaultActionWithProgressBar(action),
                            ];
                        default:
                            return ['default', defaultAction(action)];
                    }
            }
        });
        return actions.map(val => (resultType === 'values' ? val[1] : val));
    }
}

const DefaultTableActions = {
    createConfig: (service, config = [...defaultTableActionConfig]) =>
        new ActionsBuilder({ service, config }),
};
export default DefaultTableActions;
